import * as React from 'react';
import { css, Flex, styled } from '@goodrx/matisse-react';
import { Divider } from '../../../../components/Divider';
import { mediaMaxWidth } from '../../../../utils';
const Wrapper = styled(Flex)`
  padding: 32px;

  background-color: ${p => p.theme.colors.greyLightest};
  flex-direction: column;

  ${mediaMaxWidth({
  md: css`
      padding: 15px;
      > img:first-of-type {
        width: 228px;
        align-self: center;
      }
    `
})}
`;
const Grid = styled(Flex)`
  justify-content: space-evenly;
  width: 100%;

  ${mediaMaxWidth({
  md: css`
      display: grid;
      display: -ms-grid;
      padding: 0;
      grid-template-columns: 1fr 1fr 1fr;
      -ms-grid-columns: 1fr 1fr 1fr;
      justify-items: center;
      align-items: center;
      -webkit-box-align: center;
      grid-row-gap: 13px;

      img {
        width: 95px;
      }

      .item {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      .item-1 {
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 1;
        grid-row: 1;
      }

      .item-2 {
        -ms-grid-column: 2;
        grid-column: 2;
        -ms-grid-row: 1;
        grid-row: 1;
      }

      .item-3 {
        -ms-grid-column: 3;
        grid-column: 3;
        -ms-grid-row: 1;
        grid-row: 1;
      }

      .item-4 {
        -ms-grid-column: 1;
        grid-column: 1;
        -ms-grid-row: 2;
        grid-row: 2;
      }

      .item-5 {
        -ms-grid-column: 2;
        grid-column: 2;
        -ms-grid-row: 2;
        grid-row: 2;
      }

      .item-6 {
        -ms-grid-column: 3;
        grid-column: 3;
        -ms-grid-row: 2;
        grid-row: 2;
      }
    `
})}

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    justify-content: space-between;

    &:before,
    &:after {
      content: '';
      display: block;
    }
  }
`;
const HideOnMobile = styled.a`
  ${mediaMaxWidth({
  md: css`
      display: none;
    `
})}
`;
const HideOnTablet = styled.img`
  ${({
  theme
}) => css`
    @media (min-width: ${theme.breakpoints.md}) {
      display: none;
    }
  `}
`;
const StyledDivider = styled(Divider)`
  ${({
  theme
}) => css`
    @media (min-width: ${theme.breakpoints.md}) {
      display: none;
    }
  `}
`; // eslint-disable-next-line @typescript-eslint/naming-convention

export const HDHomePressLinks = ({
  className
}) => {
  return /*#__PURE__*/React.createElement(Wrapper, {
    className: className
  }, /*#__PURE__*/React.createElement(HideOnTablet, {
    alt: "HealthHub Best Telehealth",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/3MBjhhmkSDCkejK3ky0cOp/f806b532532860fbde8cd4b8ed48e047/best-telehealth-logo.svg"
  }), /*#__PURE__*/React.createElement(StyledDivider, null), /*#__PURE__*/React.createElement(Grid, {
    alignItems: "center"
  }, /*#__PURE__*/React.createElement("img", {
    className: "item item-1",
    alt: "Bloomberg logo",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/1B93hVK4iekI1IvsPuX4iL/aa2c755774b489a38b35a7f168cacabf/bloomberg-logo.svg"
  }), /*#__PURE__*/React.createElement("img", {
    className: "item item-2",
    alt: "Forbes logo",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/5xdrvak9dcbmu24GO1SGEi/ff5210f84585ac0d31d5621f03650b45/forbes-logo.svg"
  }), /*#__PURE__*/React.createElement(HideOnTablet, {
    className: "item item-3",
    alt: "Techcrunch logo",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/1B5iEcIiLRv7XpmDx7aYuH/c9e382696e80f15c69eb454e52e63434/techcrunch-logo.svg"
  }), /*#__PURE__*/React.createElement(HideOnMobile, {
    href: "https://www.healthhubsf.org/awards/winners"
  }, /*#__PURE__*/React.createElement("img", {
    alt: "HealthHub Best Telehealth",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/3MBjhhmkSDCkejK3ky0cOp/f806b532532860fbde8cd4b8ed48e047/best-telehealth-logo.svg"
  })), /*#__PURE__*/React.createElement("img", {
    className: "item item-4",
    alt: "CNBC logo",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/2VCkSfe6SeLXPDTkRDe3LW/e80b9839c66271805a33bbfb49e8bcb5/cnbc-logo.svg"
  }), /*#__PURE__*/React.createElement(HideOnTablet, {
    className: "item item-5",
    alt: "Business Insider logo",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/7LzXKpFwBZZV9V45Ogg0PM/62790540a1ba378990a7f79f450a90e9/business-insider-logo.svg"
  }), /*#__PURE__*/React.createElement("img", {
    className: "item item-6",
    alt: "Healthline",
    src: "https://images.ctfassets.net/4f3rgqwzdznj/4GOOVcdiEEi9DybKNoaytn/d075bd5ffb9b55ddfaedd14658357488/healthline.svg"
  })));
};